import http from "./create_axios";
import {centerCrop, makeAspectCrop, PixelCrop} from 'react-image-crop'
import {useLayoutEffect} from "react";
import {Alert} from "@vkontakte/vkui";
import {printCropAspectForImg} from "../utils/printCropAspect";

/**
 * Хост для /temp_static в браузере — всегда как у открытой страницы.
 * REACT_APP_API_URL задаёт только axios (API); если подставлять его в img src,
 * на http://192.168.51.150 после F5 картинки уезжают на прод-домен.
 */
function publicStaticOrigin() {
    if (typeof window !== "undefined" && window.location && window.location.origin) {
        return window.location.origin.replace(/\/$/, "");
    }
    const b = http.defaults && http.defaults.baseURL;
    return typeof b === "string" ? String(b).replace(/\/$/, "") : "";
}

class Image {
    upload(file, onUploadProgress) {
        let formData = new FormData();
        for (let i = 0; i < file.length; i++) {
            formData.append("file", file[i]);
        }
        return http.post("/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        });
    }

    getFiles(file) {
        return `${publicStaticOrigin()}/temp_static/${file}`;
    }

    /**
     * Размер медиа-бокса в координатах react-image-crop (как getBox(): getBoundingClientRect
     * на обёртке ReactCrop__child-wrapper).
     * Не static: модуль экспортирует `export default new Image()`, на экземпляре должны работать вызовы Image.getCropLayoutSize(...).
     */
    getCropLayoutSize(mediaEl) {
        if (!mediaEl || typeof mediaEl.getBoundingClientRect !== "function") {
            return {width: 0, height: 0};
        }
        const parent = mediaEl.parentElement;
        if (parent && parent.classList && parent.classList.contains("ReactCrop__child-wrapper")) {
            const r = parent.getBoundingClientRect();
            if (r.width > 0 && r.height > 0) {
                return {width: r.width, height: r.height};
            }
        }
        const r = mediaEl.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) {
            return {width: r.width, height: r.height};
        }
        return {width: mediaEl.width || 0, height: mediaEl.height || 0};
    }

    /** URL для быстрого превью (если сервер отдал preview); иначе полный файл. */
    getDisplayUrl(photo, previewThumb) {
        if (previewThumb) {
            return `${publicStaticOrigin()}/temp_static/${previewThumb}`;
        }
        return this.getFiles(photo);
    }

    initCanvas(canvas, image, withBorders = false, imgSize, callback = null, rotate) {
        let ctx = canvas.getContext('2d')
        if (!image)
            return;
        if (!ctx) {
            throw new Error('No 2d context')
        }
        ctx.imageSmoothingEnabled = false;
        //const {width, height} = image
        let width = image.naturalWidth;
        let height = image.naturalHeight;

        if (withBorders) {

            let coef;
            let height_inches;
            let width_inches;

            let horizontal_image = width>height;
            if (horizontal_image) {
                coef = image.width / image.height

                height_inches = imgSize.width / 25.4;
                width_inches = imgSize.height / 25.4;


            } else {
                coef = image.height / image.width

                height_inches = imgSize.height / 25.4;
                width_inches = imgSize.width / 25.4;
            }
            let scaleX = image.naturalWidth / image.width
            let scaleY = image.naturalHeight / image.height

            let borderstype;
            
            // если коеф изображения меньше чем коеф печатный
            
            // if (coef< imgSize.coefficient) {
            //     if (horizontal_image)
            //         borderstype = "left_right";
            //     else
            //         borderstype = "top_bottom";
            // } else {
            //    // if(rotate||)//false
            //     if (horizontal_image)
            //         borderstype = "top_bottom";
            //     else
            //         borderstype = "left_right";// !
            // }

            if (!horizontal_image) {
                if (coef <= imgSize.coefficient)
                    borderstype = "top_bottom";
                else
                    borderstype = "left_right";
            } else {
                if (coef<= imgSize.coefficient)
                    borderstype = "left_right";
                else
                    borderstype = "top_bottom";
                }


            if (coef==1 && (rotate)) {borderstype="left_right"}
            //Panyaev
            // if (borderstype === "left_right") {
            //      if (rotate) {
            //        ctx.canvas.width = (image.naturalWidth / width_inches) * height_inches;
            //        ctx.canvas.height = image.naturalWidth;
            //     } else {
            //          if (horizontal_image) {
            //              ctx.canvas.width = (image.naturalHeight / height_inches) * width_inches;
            //              ctx.canvas.height = image.naturalHeight;
            //          } else {
            //
            //                  ctx.canvas.width = (image.naturalHeight / height_inches) * width_inches;
            //                  ctx.canvas.height = image.naturalHeight;
            //              }
            //      }
            // } else { //top_bottom
            //
            //     ctx.canvas.width = (image.naturalWidth);
            //     ctx.canvas.height = ((image.naturalWidth / width_inches) * height_inches);
            // }


            if (!horizontal_image) {
                if (coef == 1) {
                    if (!rotate) {
                        ctx.canvas.width = image.naturalWidth;
                        ctx.canvas.height = (image.naturalWidth / width_inches) * height_inches;
                    } else {
                        ctx.canvas.height =image.naturalWidth;
                        ctx.canvas.width=(image.naturalWidth / width_inches) * height_inches;
                    }
                } else { //коэффициент не 1
                    if (coef <= imgSize.coefficient) {//коэффициент меньше коэффициента печатного, т е изображение ближе к квадрату
                            ctx.canvas.width = image.naturalWidth;
                            ctx.canvas.height = (image.naturalWidth / width_inches) * height_inches;
                    } else { //коэффициент больше печатного, т е изображение ближе к прямоугольнику вытянотому
                        ctx.canvas.width = (image.naturalHeight / height_inches) * width_inches;
                        ctx.canvas.height = image.naturalHeight;
                    }
                }
            } else { //горизонтальное изображение
                if (coef <= imgSize.coefficient) {//коэффициент меньше коэффициента печатного, т е изображение ближе к квадрату
                    ctx.canvas.height = image.naturalHeight;
                    ctx.canvas.width = (image.naturalHeight / height_inches) * width_inches;
                } else{ //коэффициент больше печатного, т е изображение ближе к прямоугольнику вытянотому
                    ctx.canvas.width = image.naturalWidth;
                    ctx.canvas.height = (image.naturalWidth / width_inches) * height_inches;
                }
            }


            let x;
            let y;

            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            if (horizontal_image && coef > Number(imgSize.coefficient)) {
                /* Как у вертикали с coef <= коэффициента печати: та же отрисовка, что ветка top_bottom. */
                let scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
                x = (canvas.width / 2) - (canvas.width / 2) * scale;
                y = (canvas.height / 2) - (image.naturalHeight / 2) * scale;
                ctx.drawImage(image, x, y, canvas.width * scale, image.naturalHeight * scale);
            } else if (horizontal_image) {
                /* Горизонталь, coef <= печати: вписать без искажения. */
                const fitScale = Math.min(
                    canvas.width / image.naturalWidth,
                    canvas.height / image.naturalHeight
                );
                const dw = Math.max(1, image.naturalWidth * fitScale);
                const dh = Math.max(1, image.naturalHeight * fitScale);
                x = (canvas.width - dw) / 2;
                y = (canvas.height - dh) / 2;
                ctx.drawImage(image, x, y, dw, dh);
            } else {
                let scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);

                if (borderstype === "left_right") {
                    // x = (canvas.width / 2) - (image.width / 2) * scale;
                    // y = (canvas.height / 2) - (image.height / 2) * scale;
                    // ctx.drawImage(image, x, y, image.naturalWidth * scale, canvas.height * scale);

                         x = (canvas.width / 2) - (image.naturalWidth / 2) * scale;
                         y = (canvas.height / 2) - (image.naturalHeight / 2) * scale;
                         ctx.drawImage(image, x, y, image.naturalWidth * scale, canvas.height * scale);

                } else {

                     x = (canvas.width / 2) - (canvas.width / 2) * scale;
                     y = (canvas.height / 2) - (image.naturalHeight / 2) * scale;
                     ctx.drawImage(image, x, y, canvas.width * scale, image.naturalHeight * scale);
                }
            }
        } else { //без полей

            const {width, height} = image
            const layout = this.getCropLayoutSize(image);
            const cw = layout.width > 0 ? layout.width : width;
            const ch = layout.height > 0 ? layout.height : height;
            const iw = image.naturalWidth;
            const ih = image.naturalHeight;
            const printCropAspect = printCropAspectForImg(imgSize, iw, ih, rotate);

            /* ctx.canvas.width = width * imgSize.coefficient;
             ctx.canvas.height = canvas.width * imgSize.coefficient;*/
            ctx.canvas.width = image.width
            ctx.canvas.height = image.height

            let coef = ch / cw;
            /* Кроп в тех же координатах, что у ReactCrop (layout cw×ch). */
            let crop_in_percent = centerCrop(
                makeAspectCrop(
                    {
                        unit: '%',
                        width: 100,
                    },
                    printCropAspect,
                    cw,
                    ch
                ),
                cw,
                ch
            )
            let crop_px = centerCrop(
                makeAspectCrop(
                    {
                        unit: 'px',
                        width: cw,
                    },
                    printCropAspect,
                    cw,
                    ch
                ),
                cw,
                ch
            )
            if (typeof callback === "function") {
                callback(crop_in_percent);
            }

            //this.cropPreview(image, canvas, crop_px, imgSize)
        }

    }

    cropCanvas(canvas, imgRef, cropAll) {

        const img = imgRef.current
        if (!img) {
            return;
        }
        const ctx = canvas.getContext('2d')
        if (!ctx) {
            return;
        }

        const layout = this.getCropLayoutSize(img);
        const W = layout.width > 0 ? layout.width : img.width;
        const H = layout.height > 0 ? layout.height : img.height;
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;

        let objectFit = "fill";
        try {
            objectFit =
                typeof getComputedStyle === "function" ? getComputedStyle(img).objectFit || "fill" : "fill";
        } catch (e) {
            objectFit = "fill";
        }

        ctx.fillStyle = "yellow";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.imageSmoothingQuality = 'high'

        const cx = !cropAll.hasOwnProperty("x") ? 0 : cropAll.x
        const cy = !cropAll.hasOwnProperty("y") ? 0 : cropAll.y
        const cropWidth = cropAll.width
        const cropHeight = cropAll.height

        let srcX;
        let srcY;
        let srcW;
        let srcH;
        let outputWidth;
        let outputHeight;

        if (objectFit === "contain" && W > 0 && H > 0 && nw > 0 && nh > 0) {
            const imgAr = nw / nh;
            const boxAr = W / H;
            let contentW;
            let contentH;
            let offX;
            let offY;
            if (imgAr > boxAr) {
                contentW = W;
                contentH = W / imgAr;
                offX = 0;
                offY = (H - contentH) / 2;
            } else {
                contentH = H;
                contentW = H * imgAr;
                offX = (W - contentW) / 2;
                offY = 0;
            }
            const scaleNat = nw / contentW;
            const ix1 = Math.max(cx, offX);
            const iy1 = Math.max(cy, offY);
            const ix2 = Math.min(cx + cropWidth, offX + contentW);
            const iy2 = Math.min(cy + cropHeight, offY + contentH);
            const iw = ix2 - ix1;
            const ih = iy2 - iy1;
            if (iw < 0.5 || ih < 0.5) {
                return;
            }
            srcX = (ix1 - offX) * scaleNat;
            srcY = (iy1 - offY) * scaleNat;
            srcW = iw * scaleNat;
            srcH = ih * scaleNat;
            outputWidth = Math.max(1, Math.round(srcW));
            outputHeight = Math.max(1, Math.round(srcH));
        } else {
            const scaleX = nw / W;
            const scaleY = nh / H;
            srcX = cx * scaleX;
            srcY = cy * scaleY;
            srcW = cropWidth * scaleX;
            srcH = cropHeight * scaleY;
            outputWidth = Math.max(1, Math.round(srcW));
            outputHeight = Math.max(1, Math.round(srcH));
        }

        ctx.canvas.width = outputWidth;
        ctx.canvas.height = outputHeight;

        ctx.drawImage(
            img,
            srcX,
            srcY,
            srcW,
            srcH,
            0,
            0,
            outputWidth,
            outputHeight
        )


    }


    cropPreview(
        image,//: HTMLImageElement,
        canvas,//: HTMLCanvasElement,
        crop,//PixelCrop,
        selectedSize,
        scale = 1,
        rotate = 0,
    ) {
        const {width, height} = image
        const ctx = canvas.getContext('2d')
        //const ctx2 = window.document.getElementById("cnv");

        if (!ctx) {
            throw new Error('No 2d context')
        }

        ctx.canvas.width = image.width
        ctx.canvas.height = image.height

        let scaleX = image.naturalWidth / image.width
        let scaleY = image.naturalHeight / image.height

        ctx.fillStyle = "yellow";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        //ctx.scale(pixelRatio, pixelRatio)
        let coef = selectedSize && width >= height ? (crop.width / crop.height) : scaleX

        ctx.imageSmoothingQuality = 'high'
        const cropX = (!crop.hasOwnProperty("x") ? 0 : crop.x) * scaleX
        const cropY = (!crop.hasOwnProperty("y") ? 0 : crop.y) * scaleY

        let cropWidth = crop.width
        let cropHeight = crop.height


        // const rotateRads = rotate * TO_RADIANS
        const centerX = image.width / 2
        const centerY = image.height / 2

        // ctx.save()
        // ctx.translate(centerX, centerY)
        // ctx.rotate(rotateRads)

        if (width > height) {
            ctx.drawImage(image, cropX, cropY, cropHeight * coef, cropWidth * coef, 0, 0, canvas.width, canvas.height)
        } else {
            if (width === height)
                ctx.drawImage(image, cropX, cropY, cropWidth * coef, cropHeight, 0, 0, canvas.width, image.height)
            else {
                ctx.drawImage(image, cropX, cropY, cropWidth * coef, cropHeight * coef, 0, 0, canvas.width, canvas.height)
            }
        }

        // ctx.restore()
    }

    getMinSize(imageSize) {
        if (imageSize.width <= imageSize.height)
            return imageSize.width
        else return imageSize.height
    }

    dlCanvas(canvas) {
        let dt = canvas.toDataURL('image/png');
        let href = dt.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
        window.open(href, '_blank').focus();
    };

}

export default new Image();